package com.lomdaat.ads.model

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@Serializable
@JvmInline
value class AppId(val value: String)

@Serializable
@JvmInline
value class AdsRequestId(val value: String)

@Serializable
@JvmInline
value class AdId(val value: Int)

@Serializable
@JvmInline
value class CampaignId(val value: Int)
